import React from "react";
import {
  Button,
  NewTab,
  PageHeader,
  PageTab,
  PageTitle,
} from "../../../components";
import ActiveEmployees from "./PayDataCenter/ActiveEmployees";
import ExitedEmployees from "./PayDataCenter/ExitedEmployees";
import { useNavigate } from "react-router-dom";

const PayDataCenter = () => {
  const navigate = useNavigate();
  const PayrollMenus = [
    {
      title: "Active Employees",
      page: <ActiveEmployees />,
      type: "main",
    },

    {
      title: "Exited Employees",
      page: <ExitedEmployees />,
      type: "main",
    },
  ];

  return (
    <div>
      <div>
        <PageHeader
          Section={
            <div className="flex my-3">
              <PageTitle title={"Pay Data Center"} tag="h6" />
            </div>
          }
          RightSection={
            <>
              <Button
                title="Back"
                size="sm"
                icon={"arrow_left_alt"}
                onClick={() => navigate("/payroll")}
              />
            </>
          }
        />
      </div>
      <div>
        <NewTab
          tabs={PayrollMenus}
          color="black"
          variant="outlined"
          tabLevel="employees"
        />
      </div>
    </div>
  );
};

export default PayDataCenter;
